export const getRenewalDate = (dateRendered) => `${dateRendered.toLocaleString('en-us', { month: 'long' })} ${dateRendered.getDate()}, ${dateRendered.getFullYear() + 1}`;
